/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClDrawCursor 的实体定义

import {
    _getTxtWidth,
    _drawTxtRect,
    _clearRect,
    _drawLineAlone
} from './cl.draw'
import {
    initCommonInfo
} from './cl.chart.init'
import {
    inRangeX,
    inRangeY,
    formatInfo
} from '../cl.utils'
// 创建时必须带入父类，后面的运算定位都会基于父节点进行；
// 这个类仅仅是画图, 因此需要把可以控制的rect传入进来
/**
 * Class representing ClDrawCursor
 * @export
 * @class ClDrawCursor
 */
export default class ClDrawCursor {
    /**

     * Creates an instance of ClDrawCursor.
     * @param {Object} father
     * @param {Object} rectMain
     * @param {Object} rectChart
     */
    constructor(father, cfg) {
        initCommonInfo(this, father)
        this.rectFather = father.rectMain
        this.rectMain = cfg.rectMain // 画十字线和边界标签
        this.rectChart = cfg.rectChart // 鼠标有效区域
        this.style = cfg.style || 'cross'

        this.dataLayer = father.father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo

        this.father = father
        this.axisYdata = father.axisYdata

        this.axisXInfo = father.config.axisX
        this.axisYInfo = father.config.axisY
        this.axisX = father.layout.axisX

        this.context = father.father.moveCanvas.context
        this.onClear()
    }
    /**
     * handle clear
     * @memberof ClDrawCursor
     */
    onClear() {
        // console.log(this.rectFather);
        
        _clearRect(this.context, this.rectFather.left - this.scale, this.rectFather.top, this.rectFather.width + this.scale * 5, this.rectFather.height)
    }
    /**
     * paint
     * @param {Object} mousePos
     * @param {Number} valueX
     * @param {Number} valueY
     * @memberof ClDrawCursor
     */
    drawCross(mousePos, valueX, valueY) {
        let showtxt
        let xx = mousePos.x
        let yy = mousePos.y
        const offX = 2 * this.scale
        this.static = this.dataLayer.linkInfo.static
        
        // 如果鼠标在本图区域，就画横线信息
        if (inRangeY(this.rectChart, mousePos.y)) {
            if (valueY === undefined) {
                valueY = this.axisYdata.max - (mousePos.y - this.rectChart.top) / this.axisYdata.unitY
            } else {
                yy = (this.axisYdata.max - valueY) * this.axisYdata.unitY + this.rectChart.top
            }

            let posX = this.axisPlatform === 'phone' ? 'start' : 'end'
            
            let posY = 'middle'
            {
                const th = this.axisX.pixel + this.axisX.spaceX * 2
                if (yy - th < this.rectMain.top + offX) {
                    yy = this.rectMain.top + offX;
                    posY = 'top'
                }
                if (yy + th > this.rectMain.top + this.rectMain.height - offX) {
                    yy = this.rectMain.top + this.rectMain.height - offX
                    posY = 'bottom'
                }
            }
            _drawLineAlone(this.context, this.rectMain.left, yy, this.rectMain.left + this.rectMain.width, yy, this.color.cursor)

            if (this.axisYInfo.left.display !== 'none') {
                showtxt = formatInfo(
                    valueY,
                    this.axisYInfo.left.format,
                    this.static)
                xx = this.rectMain.left
                _drawTxtRect(this.context, xx, yy, showtxt, {
                    font: this.axisX.font,
                    pixel: this.axisX.pixel,
                    spaceX: this.axisX.spaceX,
                    clr: this.color.txt,
                    bakclr: this.color.grid,
                    x: posX,
                    y: posY,
                })
            }
            if (this.axisYInfo.right.display !== 'none') {
                showtxt = formatInfo(
                    valueY,
                    this.axisYInfo.right.format,
                    this.static)
                posX = this.axisPlatform === 'phone' ? 'end' : 'start'
                xx = this.rectMain.left + this.rectMain.width
                _drawTxtRect(this.context, xx, yy, showtxt, {
                    font: this.axisX.font,
                    pixel: this.axisX.pixel,
                    spaceX: this.axisX.spaceX,
                    clr: this.color.txt,
                    bakclr: this.color.grid,
                    x: posX,
                    y: posY,
                })
            }
        }
        // console.log('========', this.rectMain)
        _drawLineAlone(this.context, mousePos.x, this.rectMain.top + this.scale, mousePos.x, this.rectMain.top + this.rectMain.height - this.scale, this.color.cursor)
        if (this.axisXInfo.display !== 'none') {
            xx = mousePos.x
            // console.log('========', valueX, JSON.stringify(this.father.data.key));
            const th = Math.floor((this.axisX.height - this.axisX.pixel - this.scale) / 2)
            yy = this.rectMain.top + this.rectMain.height + th
            const len = Math.round(_getTxtWidth(this.context, valueX, this.axisX.font, this.axisX.pixel) / 2)
            let posX = 'center'
            if (xx - len < this.rectMain.left + offX) {
                xx = this.rectMain.left + offX;
                posX = 'start'
            }
            if (xx + len > this.rectMain.left + this.rectMain.width - offX) {
                xx = this.rectMain.left + this.rectMain.width - offX
                posX = 'end'
            }
            _drawTxtRect(this.context, xx, yy, valueX, {
                font: this.axisX.font,
                pixel: this.axisX.pixel,
                spaceX: this.axisX.spaceX,
                clr: this.color.txt,
                bakclr: this.color.grid,
                x: posX,
                y: 'top'
            })
        }
    }
    drawHorLine(valueY) {
        // console.log(this.rectMain.left);
        
        _drawLineAlone(this.context, this.rectMain.left, valueY, this.rectMain.left + this.rectMain.width, valueY, this.color.cursor)
    }
    onPaint(mousePos, valueX, valueY) {
        // if (typeof this.context._beforePaint === 'function') {
        //   this.context._beforePaint()
        // }
        // console.log(this.rectChart, mousePos.y, inRangeX(this.rectChart, mousePos.x));
        // console.log(this.axisYdata, this.father.axisYdata);
        if (inRangeX(this.rectChart, mousePos.x) === false) return
        this.onClear()

        if (this.style === 'cross') {
            this.drawCross(mousePos, valueX, valueY)
        } else {
            this.drawHorLine(valueY)
        }

        // if (typeof this.context._afterPaint === 'function') {
        //   this.context._afterPaint()
        // }
    }
}